import { initializeApp } from "firebase/app";
import {
  FacebookAuthProvider,
  getAuth,
  GoogleAuthProvider,
} from "firebase/auth";
import { getMessaging, getToken } from "firebase/messaging";
import Cookies from "js-cookie";
const firebaseConfig = {
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  authDomain: "butterfly-2e6b1.firebaseapp.com",
  projectId: "butterfly-2e6b1",
  storageBucket: "butterfly-2e6b1.appspot.com",
  messagingSenderId: "263242665954",
  appId: "1:263242665954:web:e002e76906158cce1433bb",
  measurementId: "G-3D4S1L4JQ1",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

navigator.serviceWorker
  .register("/firebase-messaging-sw.js")
  .then((registration) => {
    console.log("Service Worker registered with scope:", registration.scope);
  })
  .catch((error) => {
    console.error("Service Worker registration failed:", error);
  });

export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    const token = await getToken(messaging, {
      vapidKey:
        "BFp7cMrPYzCD35pndwLxo5XXWzdX9KqF42Z_UplgoEdHnV49NT2D6YIu_Ssg1wwifA9Wph7ELm-NVt_gFfV5pLk",
    });
    if (token) {
      Cookies.set("fcmToken", token);
    }
    console.log(token, "permission");
  }
};
const auth = getAuth(app);
let provider = new GoogleAuthProvider();
let fbProvider = new FacebookAuthProvider();
export { auth, fbProvider, messaging, provider };
